import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import VueBarcode from 'vue-barcode'
import moment from 'moment'
import CryptoJS from 'crypto-js'
import printJS from 'print-js'
import Printd from 'printd'
import router from '../../../router'
import VueElementLoading from 'vue-element-loading';
import {
	Validator
} from 'vee-validate'
export default {
	name: 'po',
	components: {
		VueElementLoading,
		Paginate,
		'barcode': VueBarcode
	},

	data: function() {
		return {
			clientname: '',
			loginwarehouseid: '',
			loginClientUserId: '',
			awbno: '',
			custname: '',
			custAddress: '',
			orderNo: '',
			mobileNo: '',
			custcity: '',
			actWeight: '',
			orderDate: '',
			payMode: '',
			quantity: '',
			orderdate: '',
			itemDesc: '',
			shippingcompany: '',
			custpincode: '',
			custstate: '',
			dimention: '',
			warehouseAdd: '',
			routeDetails: '',
			showpincode: true,
			ismobileno: true,
			isLoading: false,
			collectableamount: ''
		}
	},

	created: function() {},
	filters: {
		moment: function(date) {
			return moment(date).format('DD-MM-YYYY');
		},

	},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		var loginuserid = userdetail.userid;
		var loginuseremail = userdetail.email;
		this.loginwarehouseid = userdetail.warehouseid;
		this.loginClientUserId = userdetail.clientid;
		this.getShippingLabel();
	},
	methods: {
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('DD-MMM-YYYY HH:MM')
		},


		getShippingLabel() {
			this.isLoading = true
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			/*  Calling the function for getting the cliend id*/
			var input = {
				"awbno": this.$route.query.awbno,
				"warehouseid": this.$route.query.warehouseid,
				"clientid": this.$route.query.clientid,
				"orderid": this.$route.query.orderid,
				"shippingcompany": this.$route.query.shippingcompany,
			}
			// var input = {
			//   "awbno": "AWB1004",
			//   // "awbno": "221107144194",1006379
			//   "warehouseid": 1006380,
			//   "clientid":1005
			// }
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getShippingLabel',
					'data': input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data.errorCode == 0) {
						var warehouse = {}
						var resultData = {};
						var routeDetails = {}
						var clientData = {}
						resultData = result.data.data[0]
						clientData = result.data.clientdata[0]
						warehouse = result.data.warehousedata[0]
						routeDetails = result.data.routedata[0]
						this.clientname = clientData.clientname
						this.custname = resultData.customerfirstname
						this.collectableamount = resultData.collectableamount
						if (resultData.customerlastname != '' && resultData.customerlastname != null) {
							this.custname += " " + resultData.customerlastname
						}
						this.awbno = resultData.awbno
						// if (resultData.custaddress1 != null) {
						// 	this.custAddress = resultData.custaddress1
						// } else {
						// 	this.custAddress = resultData.custaddress2
						// }
						if((resultData.custaddress1 != null || resultData.custaddress1 != '')&& (resultData.custaddress2 == null || resultData.custaddress2 == null)){
 						 this.custAddress = resultData.custaddress1;
 					 }else if((resultData.custaddress1 == null || resultData.custaddress1 == '') && (resultData.custaddress2 != null || resultData.custaddress2 != '')){
 						 this.custAddress = resultData.custaddress2;
 					 }else{
 						 this.custAddress = resultData.custaddress1+" "+ resultData.custaddress2;
 					 }
						this.city = resultData.custcity
						if (resultData.paymentmode == 'cod' || resultData.paymentmode == 'COD' || resultData.paymentmode == 'STANDARD-COD') {
							this.payMode = "COD"
						} else {
							this.payMode = "PPD"
						}
						this.routeDetails = routeDetails && routeDetails.route && routeDetails.route != undefined && routeDetails.route != '' ? routeDetails.route : null
						//  this.orderNo = resultData.shippingid
						this.orderNo = resultData.poid
						// this.quantity = resultData.prodcount
						//this.quantity = resultData.shiptotaltm
					 var qty = 0;
					 for(let i=0;i<result.data.data.length;i++){
						 qty += result.data.data[i].shiptotaltm
					 }
						this.quantity = qty;
						this.orderdate = this.dateFormat1(resultData.orderdate)
						if (resultData.custmobile != null) {
							this.mobileNo = resultData.custmobile
						} else if (resultData.billingphone != null) {
							this.mobileNo = resultData.billingphone
						} else if (this.mobileNo == '' || this.mobileNo == null) {
							this.ismobileno = false
						}
						this.custstate = resultData.custstate
						this.custcity = resultData.custcity
						this.shippingcompany = resultData.shippingcompany
						this.custpincode = resultData.custpincode
						this.dimention = parseFloat(resultData.shipmentlength).toFixed(1) + "*" + parseFloat(resultData.shipmentbreadth).toFixed(1) + "*" + parseFloat(resultData.shipmentheight).toFixed(1)
						this.warehouseAdd = warehouse.warehouseaddress + " " + warehouse.warehousepincode + " "
						this.itemDesc = resultData.proddesc
						if (this.custAddress) {
							var isFound = this.custAddress.indexOf(this.custpincode) != -1 ? true : false;
							if (isFound == true) {
								this.showpincode = false
							} else {
								this.showpincode = true
							}
						}
						this.isLoading = false;
					} else {
						console.log("no data found");
					}
					setTimeout(function() {
						this.print()
					}.bind(this), 1000)
					// }, error => {
					//   console.error(error)
				})
			/*  End Function for invoice */
			// }
			// })
		},

		SubmitPrint() {
			setTimeout(function() {
				this.print()
			}.bind(this), 1000)

		},

		print() {
			const d = new Printd();
			var buffer = '';

			var cssText = `
         body{
        -webkit-print-color-adjust:exact;
      }
         table {
             border-collapse: collapse;
             margin-left:0px !important;
         }

         table, td, th {
           border-style: solid;
      border-width: 1px;

      margin-bottom: 10px;
      border-color: rgba(0,0,255,0.25);
             padding:4px;
         }
       pre {
         color: #c7254e;
       }
       .text-right{
         text-align:right;
       }

       @media print {
       .text-primary th{
         background-color:rgb(226, 216, 216) !important;
         color:black !important;
         font-size:20px !important;
       }
       @media print {
       .text-primary tr{
         background-color:rgb(226, 216, 216) !important;
         color:black !important;
         font-size:12px;
         padding-left:5px;
       }

      }
      `
			d.print(document.getElementById('printPoContent'), cssText);
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/shippinglabel/shippinglabel.component.js